import type { ReactNode } from "react";

import { humanise, tintFor } from "@/components/table/tint";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/**
 * A value drawn as its tinted pill, for anywhere outside a table cell — a
 * detail header, an option in a dropdown — so a status is the same colour
 * where it is chosen and read as in the list it is filtered by.
 *
 * `value` picks the tint; `label` is what is shown when the two differ.
 */
export function StatusPill({
  value,
  label,
  dot = false,
  className,
}: {
  value: string;
  label?: ReactNode;
  dot?: boolean;
  className?: string;
}) {
  return (
    <Badge
      variant="secondary"
      className={cn("gap-1.5 font-normal", tintFor(value), className)}
    >
      {dot ? (
        <span
          aria-hidden
          className="size-1.5 shrink-0 rounded-full bg-current"
        />
      ) : null}
      {label ?? humanise(value)}
    </Badge>
  );
}
